/**
 * Отдать файл человеку (D54).
 *
 * Ссылка с `download` и объектный URL — единственный способ сохранить
 * файл из браузера без сервера, отдающего его заголовком. Сервер здесь
 * не при чём намеренно: содержимое уже приехало ответом процедуры,
 * и второй запрос ради того же — лишний круг.
 *
 * Уборка — следующим тактом, а не в той же строке: объектный URL,
 * освобождённый сразу после нажатия, в части браузеров отменяет
 * начавшееся сохранение. Освободить его всё равно нужно — он держит
 * содержимое в памяти вкладки до перезагрузки страницы.
 */
export function downloadFile(
  document: Document,
  fileName: string,
  text: string,
  mime: string,
): void {
  const blob = new Blob([text], { type: `${mime};charset=utf-8` })
  const url = URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = url
  link.download = fileName
  document.body.append(link)
  link.click()
  setTimeout(() => {
    link.remove()
    URL.revokeObjectURL(url)
  }, 0)
}

/** Имя файла листа: то же, что у JSON, но с другим расширением. */
export function markdownFileName(jsonFileName: string): string {
  return jsonFileName.replace(/\.json$/, '.md')
}
